<template>
  <div>
    <main class="page__container">
      <div class="container">
        <el-form ref="form" :rules="rules" :model="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Платформа" prop="id_media_core">
                <el-switch
                  v-model="form.id_media_core"
                  :active-value="MEDIA_CORE.VK3"
                  :inactive-value="MEDIA_CORE.VK2"
                  :active-text="MEDIA_CORE_NAME[MEDIA_CORE.VK3]"
                  :inactive-text="MEDIA_CORE_NAME[MEDIA_CORE.VK2]"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Название" prop="name">
                <el-input v-model="form.name" size="small" placeholder="Название" />
              </el-form-item>
            </el-col>
            <el-col v-if="!isVk3" :span="12">
              <el-form-item label="Домен" prop="domain_name">
                <el-input v-model="form.domain_name" size="small" placeholder="Домен" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col v-if="!isVk3" :span="12">
              <el-form-item label="ID" prop="server_id">
                <el-input v-model="form.server_id" size="small" placeholder="ID" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Количество камер" prop="cameras_count">
                <el-input-number id="cameras_count" v-model="form.cameras_count" :min="0" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <operators-select v-model="form.operators" />
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="API-ключ AVC панели" prop="avc_panel_api_key">
                <el-input v-model="form.avc_panel_api_key" size="small" placeholder="api_key" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="id_server_group">
                <template slot="label">
                  Группа серверов
                </template>
                <el-tooltip class="item" effect="light" placement="top-start">
                  <template slot="content">
                    Группа влияет на <code>rules.conf</code> сервера. Оставить пустым для настроек по умолчанию
                  </template>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-select
                  v-model="form.id_server_group"
                  size="small"
                  placeholder="Нет группы"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="val in serverGroups"
                    :key="val.id_server_group"
                    :label="val.server_group_name"
                    :value="val.id_server_group"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button
            v-if="$can('create', 'proxy_servers')"
            size="small"
            class="page__active_button"
            type="primary"
            :loading="fetch"
            @click="submit"
          >
            Сохранить
          </el-button>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>
<script>
import { length, required } from "@/core/helpers/validators";
import { ApiService } from "@/api";
import { mapActions } from "vuex";
import { MEDIA_CORE, MEDIA_CORE_NAME } from "@/core/helpers/const";
import OperatorsSelect from "./OperatorsSelect";

export default {
  name: "ServerCreate",
  components: { OperatorsSelect },
  data() {
    return {
      MEDIA_CORE,
      MEDIA_CORE_NAME,
      fetch: false,
      form: {
        id_media_core: MEDIA_CORE.VK3,
        name: "",
        domain_name: "",
        server_id: "",
        cameras_count: "",
        operators: [],
        avc_panel_api_key: "",
        id_server_group: "",
      },
      serverGroups: [],
    };
  },
  computed: {
    isVk3() {
      return this.form.id_media_core === MEDIA_CORE.VK3;
    },
    rules() {
      const rules = {
        name: [required(), length(3, 200)],
        cameras_count: [required("number")],
      };
      // Для ВК 3.0 (MCore) домен и ID не заполняются — name является идентификатором сервера,
      // зато обязательна привязка хотя бы к одному оператору.
      if (this.isVk3) {
        rules.operators = [required("array")];
      } else {
        rules.domain_name = [required(), length(3, 200)];
        rules.server_id = [required()];
      }
      return rules;
    },
  },
  created() {
    this.getServerGroups()
      .then((res) =>
        this.serverGroups = res
      );
  },
  methods: {
    ...mapActions("servers", {
      getServerGroups: "GET_SERVER_GROUPS",
    }),
    buildPayload() {
      if (!this.isVk3) return Object.assign({}, this.form);

      const newServer = {
        id_media_core: this.form.id_media_core,
        name: this.form.name,
        cameras_count: this.form.cameras_count,
        operators: [...this.form.operators],
      };
      if (this.form.id_server_group) newServer.id_server_group = this.form.id_server_group;
      if (this.form.avc_panel_api_key) newServer.avc_panel_api_key = this.form.avc_panel_api_key;
      return newServer;
    },
    submit() {
      let formIsValid;
      this.$refs["form"].validate((status) => {
        formIsValid = status;
      });
      if (!formIsValid) return false;

      this.loading = true;
      ApiService.servers
        .create(this.buildPayload())
        .then((response) => {
          this.$router.push({
            name: "servers:edit",
            params: { id: response.data.id },
          });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.response.data.error || "Неизвестная ошибка",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.page_container {
  padding: 20px;
}
</style>
